import { DefaultFontFamily } from 'app/common/react/components/common/FontFamily';

const cssStyles = () => `
html {
  background-color: #fff;
}

html, body {
  font-family: ${DefaultFontFamily};
  color: rgb(33, 25, 34);
  font-size: 12px;
  height: 100%;
}

body {
  position: relative;
  overflow-y: scroll;
}

input::-ms-clear {
  display: none;
}

a {
  color: #717171;
  font-weight: bold;
  text-decoration: none;
}

a:focus,
a:hover {
  color: #8a8a8a;
}

ul {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
  padding: 0;
}

:focus {
  outline: #d1d1d1 auto 1px
}

button, input, select, textarea {
  font-family: ${DefaultFontFamily};
  font-size: 100%;
  vertical-align: middle;
  margin: 0px;
}

.SkipToContent {
  display: none;
}

`;
export default cssStyles;
